import { TrackingDomain } from '@/models/tracking-domain/tracking-domain';
import { MailWizzInstanceService } from './mail-wizz-instance.serive';

export class TrackingDomainsService extends MailWizzInstanceService {
    protected getResourceUrl() { return 'api/trackingDomains' };
    protected getResponseMapper() { return TrackingDomain.parseJson }

    public getLocked(): Promise<number[]> {
        return this.getAll<number>({
            path: '/locked'
        });
    }
}

export const trackingDomainsService = new TrackingDomainsService();